var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Styles from './my-portfolio-brokerage-styles.scss';
import { Table, ButtonKVBase, CircleLoader, DefaultModal, HeaderMenu, TabHeader, Loading } from '@/presentation/components';
import { IconActivity } from '@/presentation/components/icons';
import { useNavigate } from 'react-router';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import PortfolioCardSmall from './components/porfolio-card-small/porfolio-card-small';
import InvestmentPositions from './components/investment-positions/investment-positions';
import PositionDetails from './components/position-details/position-details';
import colors from '../../styles/colors.scss';
import DataNotFoundComp from '../all-students/components/data-not-found';
import useTransactionTable from '../my-wallet/checking-account/hooks/useTransactionTable';
import { transactionTableBrokerageState } from '../my-wallet/checking-account/components/atoms';
import { useRecoilState } from 'recoil';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { parseNumberMoney } from '@/presentation/utils/number-utils';
import { useChartPositions } from './hooks/use-chart-positions';
import useValidateUserActivity from '@/presentation/hooks/use-validate-user-activity';
const MyPortfolioBrokerage = ({ manageVirtualTransactions, manageApiStonk, isAllowed = false }) => {
    const [modalConfirm, setModalConfirm] = useState(false);
    const [purchaseList, setPurchaseList] = useState([]);
    const [networth, setNetworth] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useUserSesssion();
    const onGoStock = (e) => {
        setModalConfirm(false);
        navigate('/student-dashboard/activities/stock');
    };
    const navigate = useNavigate();
    const { brokageAccount } = useStudentAccounts(false);
    const [state, setState] = useRecoilState(transactionTableBrokerageState);
    const { chartData, total } = useChartPositions({ items: purchaseList });
    const { columns, columnsWithoutSort, getTransactionsPaginated, renderCellByType } = useTransactionTable({
        manageVirtualTransactions,
        virtualAccountIds: [brokageAccount === null || brokageAccount === void 0 ? void 0 : brokageAccount.id],
        mainTableState: transactionTableBrokerageState
    });
    const getNetwork = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const response = yield manageApiStonk.getNetwork(user === null || user === void 0 ? void 0 : user.id);
        setIsLoading(false);
        if (response === null || response === void 0 ? void 0 : response.networth) {
            setNetworth(response === null || response === void 0 ? void 0 : response.networth);
        }
    });
    const getPurchasedStock = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const response = yield manageApiStonk.getPurchasedStock(user === null || user === void 0 ? void 0 : user.id);
        setIsLoading(false);
        if ((response === null || response === void 0 ? void 0 : response.length) > 0) {
            setPurchaseList(response.map(item => {
                const customAmount = (item === null || item === void 0 ? void 0 : item.amount) || 0;
                const customQuantity = (item === null || item === void 0 ? void 0 : item.stockAmount) || 0;
                const customPrice = customAmount / customQuantity;
                return Object.assign(Object.assign({}, item), { customAmount, customQuantity, customPrice });
            }));
        }
        else {
            setPurchaseList([]);
        }
    });
    const initData = () => __awaiter(void 0, void 0, void 0, function* () {
        yield Promise.all([getNetwork(), getPurchasedStock()]);
    });
    useEffect(() => {
        initData();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.mainContainer },
            React.createElement("div", { style: {
                    background: '#f3f3f9',
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '1rem 2rem',
                    gridArea: 'header'
                } },
                React.createElement("div", null,
                    React.createElement(HeaderMenu, { title1: "My porfolio", title2: "My Brokerage Account", onBack: () => navigate(`/student-dashboard/my-portfolio/overview`) })),
                React.createElement("div", null,
                    React.createElement(ButtonKVBase, { onClick: () => setModalConfirm(true), type: "button", rightIcon: React.createElement(IconActivity, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: isLoading || !isAllowed }, 'Start Trading'))),
            React.createElement(PortfolioCardSmall, { style: Styles.stocks, title: 'Stocks', text: 'Your Account Value', amount: parseNumberMoney(networth) }),
            React.createElement(PortfolioCardSmall, { style: Styles.realEstate, title: 'Cash Balance', text: 'Funds available for trading', amount: parseNumberMoney((brokageAccount === null || brokageAccount === void 0 ? void 0 : brokageAccount.balance) || 0) }),
            React.createElement("div", { className: Styles.lifetime }, isLoading ? (React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(CircleLoader, null))) : (React.createElement(PositionDetails, { title: 'Position Details', purchaseList: purchaseList }))),
            React.createElement("div", { className: Styles.daily },
                React.createElement(InvestmentPositions, { chartHeight: '18.75rem', chartWidth: '18.75rem', items: chartData, total: total, loading: isLoading }))),
        React.createElement("div", { style: { backgroundColor: '#f3f3f9' } },
            React.createElement("div", { className: Styles.table },
                React.createElement(TabHeader, { title: "Transaction History" }),
                React.createElement(Table, { columns: columns, data: state.transactions.data, 
                    // dataNotFound={state.dataNotFound}
                    DataNotFoundComponent: () => {
                        return React.createElement(DataNotFoundComp, null);
                    }, columnsWithoutSort: columnsWithoutSort, renderCellByType: renderCellByType, pagination: {
                        total: state.transactions.total,
                        page: state.transactions.page,
                        count: state.transactions.count,
                        pageCount: state.transactions.pageCount
                    }, fetchData: (pagination, sort) => {
                        getTransactionsPaginated(state.filters, pagination, sort);
                    }, filters: state.filters, loading: state.isTableLoading })),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)),
        React.createElement(DefaultModal, { height: "435", hUnit: "px", width: "512", wUnit: "px", open: modalConfirm, onClose: () => setModalConfirm(false), showClose: true, overlayCustomStyles: { zIndex: 9999 } },
            React.createElement("div", { className: Styles.modalContent },
                React.createElement("div", { className: Styles.icon },
                    React.createElement(IconActivity, { color: colors.invitedText, style: { width: 64, height: 64 } })),
                React.createElement("div", { className: Styles.title },
                    React.createElement("div", { className: Styles.main }, "It's time to trade!"),
                    React.createElement("div", { className: Styles.description }, 'Use what you have learned about the stock market to purchase your first three stocks.')),
                React.createElement(ButtonKVBase, { onClick: onGoStock, type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)" }, 'Start')))));
};
const MyPortfolioBrokerageWrapper = (props) => {
    const { isAllowed, isLoading } = useValidateUserActivity('STOCK_TRADING');
    if (isLoading) {
        return (React.createElement("div", { className: Styles.mainContainer },
            React.createElement("div", { style: {
                    background: '#f3f3f9',
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '1rem 2rem',
                    gridArea: 'header'
                } },
                React.createElement(Loading, null))));
    }
    if (isAllowed) {
        return React.createElement(MyPortfolioBrokerage, Object.assign({}, props, { isAllowed: isAllowed }));
    }
    return (React.createElement("div", { className: Styles.mainContainer },
        React.createElement("h2", null, "Not allowed")));
};
export default MyPortfolioBrokerageWrapper;
